export default "__VITE_ASSET__CxJYiuPL__"